import { render, staticRenderFns } from "./ability-radar.vue?vue&type=template&id=65d3f6ce&scoped=true"
import script from "./ability-radar.vue?vue&type=script&lang=js"
export * from "./ability-radar.vue?vue&type=script&lang=js"
import style0 from "./ability-radar.vue?vue&type=style&index=0&id=65d3f6ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d3f6ce",
  null
  
)

export default component.exports